import i18n from 'modules/core/lib/i18n'

import type { ResultType, SearchPlugin, SearchPluginHook } from 'modules/command_bar/lib/types'
import { useSearchSettings } from 'modules/settings/hooks/useSearchSettings'
import { useSettings } from 'modules/settings/hooks/useSettings'
import { F0Icon } from '@factorialco/f0-react'

const DEFAULT_SCORE = 0.2
const MAX_AMOUNT_TO_SHOW = 5

const useSettingsPlugin: SearchPluginHook = (search) => {
  const { settings } = useSettings()
  const filteredSettings = useSearchSettings(search, settings)
  const settingsChildren = filteredSettings.flatMap((setting) => setting.children)

  const results = settingsChildren.slice(0, MAX_AMOUNT_TO_SHOW).map(
    (settingsChild): ResultType => ({
      id: settingsChild.id,
      text: settingsChild.title,
      IconComponent: () => <F0Icon icon={settingsChild.icon} />,
      type: 'navigation',
      navigationPath: settingsChild.url,
      score: DEFAULT_SCORE,
    })
  )

  return {
    id: 'setings',
    results,
    title: i18n.t('company_settings.title'),
    loading: false,
  }
}

export const settingsPlugin: SearchPlugin = {
  hook: useSettingsPlugin,
  filter: () => false,
}
